// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M12.1578 1.59573C14.0866 1.91719 15.5002 3.58595 15.5002 5.54131L15.5002 7.99992L20.8198 7.99992C22.0557 7.99992 22.9958 9.10966 22.7926 10.3287L21.1259 20.3287C20.9652 21.2931 20.1308 21.9999 19.1531 21.9999H7.00024L7.00025 10.8021L10.8789 1.38257L12.1578 1.59573Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M4.00024 21.9999H2.00024L2.00025 9.99992H4.00025L4.00024 21.9999Z"}}]};

const ThumbUpFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'thumb-up-filled',
    ref,
    icon: element,
  },
));

ThumbUpFilledIcon.displayName = 'ThumbUpFilledIcon';

export default ThumbUpFilledIcon;
